import Vue from "vue";
import VueRouter from "vue-router";
import rolesServices from "../services/roles";

const Recovery = () =>
  import(/* webpackChunkName: "user-bundle" */ "../views/Recovery.vue");
const PwdReset = () =>
  import(/* webpackChunkName: "rare-bundle" */ "../views/Reset.vue");
const Profile = () =>
  import(/* webpackChunkName: "rare-bundle" */ "../views/Profile.vue");
const TermAndConditions = () =>
  import(
    /* webpackChunkName: "rare-bundle" */ "../views/TermAndConditions.vue"
  );
const BackOfficeUsers = () =>
  import(/* webpackChunkName: "rare-bundle" */ "../views/Backoffice/Users.vue");

const BackOfficeSites = () =>
  import(/* webpackChunkName: "rare-bundle" */ "../views/Backoffice/Sites.vue");

import store from "../store";
import config from "../config"

import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import Wizard from "../views/Wizard.vue";
import Editor from "../views/EditSite.vue";

import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/wizard",
    name: "Wizard",
    components: {
      header: Header,
      main: Wizard,
      footer: Footer,
    },
    meta: {
      title: "Aki Digital Solutions - eGin",
    },
  },
  {
    path: "/editor",
    name: "Editor",
    components: {
      header: Header,
      main: Editor,
      footer: Footer,
    },
    meta: {
      title: "Aki Digital Solutions - eGin",
    },
  },

  {
    path: "/",
    name: "Home",
    components: {
      header: Header,
      main: Home,
      footer: Footer,
    },
  },
  {
    path: "/term-and-conditions",
    name: "TermAndConditions",
    components: {
      main: TermAndConditions,
      header: Header,
      footer: Footer,
    },
  },
  {
    path: "/login",
    name: "Login",
    components: {
      main: Login,
      header: Header,
      footer: Footer,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    components: {
      header: Header,
      main: Profile,
      footer: Footer,
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    },
  },
  {
    path: "/recovery",
    name: "recovery",
    components: {
      main: Recovery,
      header: Header,
      footer: Footer,
    },
  },
  {
    path: "/reset",
    name: "reset",
    components: {
      header: Header,
      main: PwdReset,
      footer: Footer,
    },
  },
  {
    path: "/backoffice/users",
    name: "backoffice-users",
    components: {
      header: Header,
      main: BackOfficeUsers,
      footer: Footer,
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/backoffice/sites",
    name: "backoffice-sites",
    components: {
      header: Header,
      main: BackOfficeSites,
      footer: Footer,
    },
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

router.beforeEach((to, from, next) => {
  if (to.path == "/") {
    let host = window.location.host;
    // Remove : and /
    let parts = host.split(":");
    if (parts.length) host = parts[0];
    parts = host.split("/");
    if (parts.length) host = parts[0];

    // Check if we have a build in progress and no sites (redirect to /wizard) otherwise redirect to /dashboard
    if (store.state.wizard.build_state_id || !store.state.user.id)
      next("/wizard" + to.fullPath);
    else next();
    return;
    //}
  } else if (to.path == "/login") {
    if (store.state.isLogged()) next("/wizard");
    else next();
    return;
  } else if (to.path == "/editor") {
    next();
    return;
  } else if (to.path.indexOf("/wizard") == 0) {
    let host = window.location.host;
    // Remove : and /
    let parts = host.split(":");
    if (parts.length) host = parts[0];
    parts = host.split("/");
    if (parts.length) host = parts[0];

    //if (host == "egyn.aki-digitalsolutions.com" || host == "localhost") {
    // Check if we have a build in progress and no sites (redirect to /wizard) otherwise redirect to /dashboard
    if (!store.state.wizard.build_state_id && store.state.user.id) {
      next("/");
      return;
    }
    next();
    //else if (!store.state.wizard.build_state_id) next("/login")
    //return;
    //}
  } else {
    document.title = to.meta.title || ("Aki Digital Solutions " + config.appName);

    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (to.meta.requiresAdmin && !rolesServices.isAdmin(store.state)) {
        next("/login");
        return;
      }

      if (
        to.meta.requiresSuperAdmin &&
        !rolesServices.isSuperAdmin(store.state)
      ) {
        next("/login");
        return;
      }

      if (store.state.user.id > 0) {
        next();
        return;
      }
      next("/login");
    } else {
      next();
    }
  }
});

export default router;
